export default __webpack_public_path__ + "static/media/greenline-new-logo.331775fc.svg";